import { Form, Modal, useEffect } from 'external/react'
import usePackage from 'context/package-context/hook'

import FormTextfield from 'components/FormTextfield'

import useFormValidation, { validators } from 'utilities/form-validation'
import { offerService } from 'services/offer.service'
import { notifySuccess } from 'components/Notify'
import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'
import { clearedChangedPackageAlias } from 'types/context/package'

const { createRequiredFieldValidation} = validators

const planAliasValidations = {
	plan_alias: [createRequiredFieldValidation('plan_alias')]
}

export default function ChangePackageAlias() {

	const {state: {modals: {changePackageAlias: modal}}, update} = usePackage()
	const [errors, validate] = useFormValidation(planAliasValidations);

	function handleClose() {
		update({modals: {changePackageAlias: {$shallow: clearedChangedPackageAlias}}})
	}

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: modal[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e) => {
				update({modals: {changePackageAlias: {[fieldName]: {$set: e.target.value}}}})
			}
		}
	}

	async function handleChangeAlias (e: { preventDefault: () => void }) {
		e.preventDefault()
		if (!validate(modal, true)) return;
		const request = {purchaseitemid: modal.id, plan_alias: modal.plan_alias}
		const response = await offerService.updateCustomNameOffer(request)
		update({packages: {items: {[modal.index]: {plan_alias: {$set: modal.plan_alias}}}}})
		notifySuccess('Se actualizó el alias correctamente.')
		handleClose()
	}


	useEffect(() => { validate(modal, false)}, [modal])


	return (
		<Modal show={modal.open} onHide={handleClose} size='lg' centered>
			<Modal.Header closeButton>
				<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }}>Editar</h5>
			</Modal.Header>
			<Modal.Body>
				<div className='row mb-3'>
					<div className='col-12'>
						<Form>
							<Form.Group>
								<Form.Label>
									Ingrese un alias para identificar su plan
								</Form.Label>
								<FormTextfield {...createFieldProps('Nombre', 'plan_alias', 35)} />
						</Form.Group>
						</Form>
					</div>
				</div>
			</Modal.Body>
			<ModalAcceptCancelFooter onCancel={handleClose} onAccept={handleChangeAlias} />
		</Modal>
	)
}